import { ReactComponent as GridSvg } from "./svg/grid.svg";
import { ReactComponent as GridBoldSvg } from "./svg/grid-bold.svg";
import { ReactComponent as ChartSvg } from "./svg/chart.svg";
import { ReactComponent as ChartBoldSvg } from "./svg/chart-bold.svg";

import "./results-header.css";

const modes = [
   {
      value: "table",
      label: "Tabela",
      Svg: GridSvg,
      SvgActive: GridBoldSvg
   },
   {
      value: "chart",
      label: "Wykres",
      Svg: ChartSvg,
      SvgActive: ChartBoldSvg
   }
]

export default function ResultsHeader({ heading, mode, onModeChange, onBackToSteps }) {
   return (
      <div className="results-header">
         <div className="results-header-left">
            { onBackToSteps && (
               <div className="results-header-breadcrumbs">
                  <button 
                     className="results-header-back-btn"
                     onClick={ onBackToSteps }
                     aria-label="Wybierz nowe zmienne"
                  >
                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                     </svg>
                     <span>Wybierz nowe zmienne</span>
                  </button>
               </div>
            )}
            { heading && <h3> { heading } </h3> }
         </div>

         <div className="results-header-mode-switch">
            { modes.map(({ value, label, Svg, SvgActive }) => {
               
               const is_active = value === mode;

               return (
                  <div 
                     key={ value } 
                     className={ is_active ? "active" : "" }
                     role="button"
                     aria-pressed={is_active}
                     aria-label={`Przełącz na widok ${label.toLowerCase()}`}
                     tabIndex={0}
                     onClick={() => onModeChange( value )}
                     onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                           e.preventDefault();
                           onModeChange( value );
                        }
                     }}
                  >
                     { !is_active ? <Svg aria-hidden="true"/> : <SvgActive aria-hidden="true"/> }
                     <span> { label } </span>
                  </div>
               )
            })}
         </div>
      </div>
   )
}